const SET_ACTIVE_EDITOR_LOCATION = 'root/SET_ACTIVE_EDITOR_LOCATION';
const SET_IS_STUDENT_PREVIEW = 'root/SET_IS_STUDENT_PREVIEW';
const SET_IS_CLASS_PREVIEW = 'root/SET_IS_CLASS_PREVIEW';
const SET_ACTIVE_EDITOR_ID = 'root/SET_ACTIVE_EDITOR_ID';
const SET_IS_PAGE_PREVIEW = 'root/SET_IS_PAGE_PREVIEW';
const SET_PAGE_INDEX = 'root/SET_PAGE_INDEX';
const SET_SELECTED = 'root/SET_SELECTED';
const SET_BUSY = 'SET_BUSY';

export default {
  SET_ACTIVE_EDITOR_LOCATION,
  SET_IS_STUDENT_PREVIEW,
  SET_IS_CLASS_PREVIEW,
  SET_ACTIVE_EDITOR_ID,
  SET_IS_PAGE_PREVIEW,
  SET_PAGE_INDEX,
  SET_SELECTED,
  SET_BUSY,
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js